import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import type { Music24PlanTier } from 'fym-shared/src/music24/music24Plans';
import { TypedMemo } from '../../../common/types';
import { LADDER_TIERS, PLAN_NAMES, planRate } from './planRates';
import { whoMessages as messages } from './whoMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for step 2; each part uses its own slice of it */
import styles from './Who.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The pitches a day of the four paid plans, with the plan of the workspace marked (design c1). */
const PlanLadderComponent: React.FC<{ plan: Music24PlanTier }> = ({ plan }) => {
  const intl = useIntl();
  const rungs = useMemo(
    () =>
      LADDER_TIERS.map((tier) => {
        const isYou = tier === plan;
        const name = intl.formatMessage(PLAN_NAMES[tier]);
        const unit =
          tier === 'label' ? messages.aDayAutopilot : tier === 'manager' ? messages.aDayPerArtist : messages.aDay;
        return (
          <div
            key={tier}
            className={clsx(styles.rung, isYou && styles.rungYou, tier === 'label' && !isYou && styles.rungBest)}
            data-testid={`plan-rung-${tier}`}
          >
            <span className={styles.rungKey}>
              {isYou ? intl.formatMessage(messages.ladderYou, { plan: name }) : name}
            </span>
            <span className={styles.rungValue}>
              {planRate(tier)}
              <small>{intl.formatMessage(unit)}</small>
            </span>
          </div>
        );
      }),
    [intl, plan]
  );
  return <div className={styles.ladder}>{rungs}</div>;
};

export const PlanLadder = TypedMemo(PlanLadderComponent);
